import { APIService } from "../../common/APIService";
import { Quote } from "../../dto/Quote";
import { QuoteAttachmentTemplate } from "../../dto/QuoteAttachmentTemplate";

export class ProjectFileTemplateService extends APIService {
  public async browse() {
    const json = await this.getJson<{ data: object[] }>(`projects/file-templates`)
    return json.data.map(item => QuoteAttachmentTemplate.fromJson(item))
  }
  public async add(files: File[]) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files[]', file, file.name)
    })
    await this.postForm(`projects/file-templates`, formData)
  }
  public async rename(templateId: string, name: string) {
    const json = await this.putJson<{ data: object[] }>(`projects/file-templates/${templateId}`, {
      filename: name
    })
    return Quote.fromJson(json.data)
  }
  public async replaceFile(templateId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name)
    await this.putForm(`projects/file-templates/${templateId}`, formData)
  }
  public async download(templateId: string): Promise<Blob> {
    const response = await this.getRaw(`projects/file-templates/${templateId}/download`)
    return await response.blob()
  }
  public async delete(templateId: string) {
    await this.deleteJson(`projects/file-templates/${templateId}`)
  }
}
